import * as types from './AgreementsActionTypes';
import AgreementsApi from './AgreementsApi';
import {
    IAgreement,
    IProductType,
    ICreateAgreement,
    IEditAgreementViewModel,
    IPhotographer,
    IUpdatePhotographerAgreement
} from './Entities';

function loadAgreementsSuccess(agreements: IAgreement[]) {
    return { type: types.LOAD_AGREEMENTS_SUCCESS, result: agreements };
}

export function listAgreements() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.listAgreements().then((result: IAgreement[]) => {
            dispatch(loadAgreementsSuccess(result));
        });
}

function newAgreementSuccess(productTypes: IProductType[]) {
    return { type: types.NEW_AGREEMENT_SUCCESS, result: productTypes };
}

export function newAgreement() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.newAgreement().then((result: IProductType[]) => {
            dispatch(newAgreementSuccess(result));
        });
}

function createAgreementSuccess(agreement: IAgreement) {
    return { type: types.CREATE_AGREEMENT_SUCCESS, result: agreement };
}

export function createAgreement(agreement: ICreateAgreement) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.createAgreement(agreement).then((result: IAgreement) => {
            dispatch(createAgreementSuccess(result));
        });
}

function editAgreementSuccess(agreement: IEditAgreementViewModel) {
    return { type: types.EDIT_AGREEMENT_SUCCESS, result: agreement };
}

export function editAgreement(id: number) {
    return (dispatch: (result: any) => void, getState: (Error: any) => void) =>
        AgreementsApi.editAgreement(id).then((result: IEditAgreementViewModel) => {
            dispatch(editAgreementSuccess(result));
        });
}

function updateAgreementSuccess(agreement: IAgreement) {
    return { type: types.UPDATE_AGREEMENT_SUCCESS, result: agreement };
}

export function updateAgreement(agreement: IEditAgreementViewModel) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.updateAgreement(agreement).then((result: IAgreement) => {
            dispatch(updateAgreementSuccess(result));
        });
}

function deleteAgreementSuccess(id: number) {
    return { type: types.DELETE_AGREEMENT_SUCCESS, result: id };
}

export function deleteAgreement(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.deleteAgreement(id).then(() => {
            dispatch(deleteAgreementSuccess(id));
        });
}

function checkDeleteAgreementSuccess(photographers: IPhotographer[]) {
    return {
        type: types.CHECK_DELETE_AGREEMENT_SUCCESS,
        result: photographers
    };
}

export function checkDeleteAgreement(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.checkDeleteAgreement(id).then((result: IPhotographer[]) => {
            dispatch(checkDeleteAgreementSuccess(result));
        });
}

function updatePhotographerAgreementSuccess(result: any) {
    return { type: types.UPDATE_PHOTOGRAPHER_AGREEMENT_SUCCESS, result };
}

export function updatePhotographerAgreement(photographers: IUpdatePhotographerAgreement[]) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AgreementsApi.updatePhotographerAgreement(photographers).then((result: any) => {
            dispatch(updatePhotographerAgreementSuccess(result));
        });
}
